import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-y-lg" }
const _hoisted_2 = { class: "flex no-wrap q-gutter-x-md" }
const _hoisted_3 = { class: "text-h4 q-mb-xs" }

import {PropType} from 'vue';
import {Business} from 'src/models/business.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationsTabPanel',
  props: {
  business: {
    type: Object as PropType<Business>,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.business?.locations, (location) => {
      return (_openBlock(), _createElementBlock("div", {
        key: location,
        class: "col-12 col-sm-6"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_q_icon, {
              class: "grey-6",
              name: "far fa-building",
              size: "md"
            })
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(location.city), 1),
            _createElementVNode("div", null, _toDisplayString(location.address_line), 1)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})